export interface Company {
	name: string;
	logoSrc: string;
	imageSrc: string;
	linkSrc: string;
}

export interface Country {
	name: string;
	location: "East" | "West";
	companies: Company[];
}

export const countries = [
	{
		name: "Poland",
		location: "East",
		companies: [
			{
				name: "Animex",
				logoSrc: "/img/svg/animex.svg",
				imageSrc:
					"/img/webp/european-operations/countries/map-img_0007_animex.webp",
				linkSrc: "https://www.animex.pl/",
			},
			{
				name: "Agri Plus",
				logoSrc: "/img/webp/european-operations/countries/agri-plus.webp",
				imageSrc:
					"/img/webp/european-operations/countries/map-img_0008_agri-plus.webp",
				linkSrc: "https://www.agriplus.pl/en/",
			},
			{
				name: "Pupil Foods",
				logoSrc: "/img/webp/pupil-foods.webp",
				imageSrc: "/img/webp/european-operations/countries/map-image-pupil.webp",
				linkSrc: "https://pupilfoods.pl/"
			}
		],
	},
	{
		name: "Slovakia",
		location: "East",
		companies: [
			{
				name: "Mecom",
				logoSrc: "/img/svg/mecom.svg",
				imageSrc:
					"/img/webp/european-operations/countries/map-img_0003_mecom-slo.webp",
				linkSrc: "https://www.mecom.sk/en/o-nas/",
			},
		],
	},
	{
		name: "Hungary",
		location: "East",
		companies: [
			{
				name: "Mecom",
				logoSrc: "/img/svg/mecom.svg",
				imageSrc:
					"/img/webp/european-operations/countries/map-img_0000_mecom-hun.webp",
				linkSrc: "https://www.mecom.sk/en/o-nas/",
			},
		],
	},
	{
		name: "Romania",
		location: "East",
		companies: [
			{
				name: "Comtim",
				logoSrc: "/img/svg/comtim-romania.svg",
				imageSrc:
					"/img/webp/european-operations/countries/map-img_0002_comtim.webp",
				linkSrc: "https://comtimromania.ro/",
			},
			{
				name: "Elit",
				logoSrc: "/img/svg/elit.svg",
				imageSrc:
					"/img/webp/european-operations/countries/map-img_0001_elit.webp",
				linkSrc: "https://mezeluri.ro/despre-noi/",
			},
		],
	},
	{
		name: "France",
		location: "West",
		companies: [
			{
				name: "Michel Ogier",
				logoSrc: "/img/webp/european-operations/countries/michel-ogier.webp",
				imageSrc:
					"/img/webp/european-operations/countries/map-img_0005_ogier.webp",
				linkSrc: "https://www.salaisonogier.com/",
			},
		],
	},
	{
		name: "Spain",
		location: "West",
		companies: [
			{
				name: "Argal",
				logoSrc: "/img/webp/argal.webp",
				imageSrc:
					"/img/webp/european-operations/countries/map-img_0004_argal.webp",
				linkSrc: "https://argal.com/international/",
			},
		],
	},
	{
		name: "UK",
		location: "West",
		companies: [
			{
				name: "Morliny Foods",
				logoSrc: "/img/svg/logo.svg",
				imageSrc:
					"/img/webp/european-operations/countries/map-img_0006_morliny-foods.webp",
				linkSrc: "https://www.morlinyfoods.co.uk/",
			},
		],
	},
	{
		name: "Germany",
		location: "West",
		companies: [
			{
				name: "Wolf",
				logoSrc: "/img/webp/wolf.webp",
				imageSrc: "/img/webp/european-operations/countries/map-image-wolf.webp",
				linkSrc: 'https://wolf-essgenuss.de/'
			}
		],
	}
];

export const countryDotOffsets: Record<string, { x: number; y: number }> = {
	UK: { x: 3, y: 40 },
	Poland: { x: 0, y: 15 },
	Slovakia: { x: -10, y: 5 },
	Hungary: { x: 10, y: -5 },
	Romania: { x: 0, y: -10 },
	France: { x: 5, y: 15 },
	Spain: { x: 0, y: 12 },
	Germany: { x: 0, y: 15 },
};
